import { render, staticRenderFns } from "./RsaConfigurazioneProfiliLisEditPage.vue?vue&type=template&id=7be64060"
import script from "./RsaConfigurazioneProfiliLisEditPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneProfiliLisEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports